import { render } from "./Notifications.vue?vue&type=template&id=0f984c52"
import script from "./Notifications.vue?vue&type=script&lang=js"
export * from "./Notifications.vue?vue&type=script&lang=js"
script.render = render

export default script